import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { Partner } from 'types';

import EmptyStateForTable from 'modules/_shared/components/EmptyStates/EmptyStateForTable';

import { useOperationDetailsPage } from '../../context/OperationDetailsPageContext';
import ContributionOperationTableRow from './ContributionOperationTableRow';
import { getPartnersFromOldContribution } from '../../utils/getPartnersFromOldContributions';

const ContributionOperationTableBody: FC = () => {
  const { t } = useTranslate();

  const { data } = useOperationDetailsPage();

  const partners = data.isOldOperation
    ? getPartnersFromOldContribution(data.operation)
    : data.partners;

  const hasData = partners?.length > 0;

  return (
    <>
      {hasData ? (
        <tbody>
          {partners?.map((partner: Partner, index: number) => (
            // eslint-disable-next-line react/no-array-index-key
            <tr className="nk-tb-item" key={`contribution-data-row-${index}`}>
              <ContributionOperationTableRow index={index} partner={partner} />
            </tr>
          ))}
        </tbody>
      ) : (
        <EmptyStateForTable
          mainMessage={t('NoDataFound')}
          infoMessage=""
          colspan={7}
        />
      )}
    </>
  );
};

export default ContributionOperationTableBody;
